import ProgressUpload from 'modules/ImageresizeApi/ProgressUpload';
import { removeExtension, simplifyUrl } from 'utils';

const _VERSION = 'v2';
const BASE_URL = process.env.REACT_APP_BASE_URL; // eslint-disable-line no-process-env

const s3URL = '//files.imageresize.org/';

// Check the status of a fetch response and fail appropriately
function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  } else {
    var error = new Error(response.statusText);
    error.response = response;
    throw error;
  }
}

// Make a POST request to the /api/v1/images API
function postImages(images) {
  const body = new FormData();

  // Add all images to the form data object
  images.forEach((image) => {
    body.append(`${image.uploadType}[]`, image.value);
  });

  // Return an instance of ProgressUpload
  return new ProgressUpload({
    url: `/api/${_VERSION}/images`,
    body
  });
}

// Get the URL to download the image
function getImageDirectUrl(imageId) {
  return s3URL + imageId.replace('-', '/');
}
// Get the URL to download the image
function getImageUrl(imageId, filename, version) {
  if(!version) version = _VERSION;
  // let url = `https://s3.amazonaws.com/image-resize-data/images/${imageId}`;
  let url = `/api/${version}/images/${imageId}`;

  if (filename) {
    url += `?contentDispositionFilename=${removeExtension(filename)}`;
  }

  return url;
}

// Get the metadata for an image
function requestImageMetadata(imageId, version) {

  if(!version) version = _VERSION;

  return fetch(`/api/${version}/images/${imageId}/metadata`)
    .then(checkStatus)
    .then((response) => response.json());
}

// Update metadata for the given image
function updateImageMetadata(imageId, metadata) {
  return fetch(`/api/${_VERSION}/images/${imageId}/metadata`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(metadata)
  })
    .then(checkStatus)
    .then((response) => response.json());
}

// Report an image for violating the terms of service
function reportImage(imageId, reportReason, version) {
  if(!version) version = _VERSION;
  return fetch(`/api/${version}/images/${imageId}/reports`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      input: {
        reason: reportReason
      }
    })
  })
    .then(checkStatus)
    .then((response) => response.json());
}

// Make a POST request to the /api/v1/imageEditors API
function editImages(images) {
  return fetch(`/api/${_VERSION}/imageEditors`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      input: {
        images
      }
    })
  })
  .then(checkStatus)
  .then((response) => response.json());
}

function deleteImage(imageId) {
  return fetch(`/api/${_VERSION}/images/${imageId}/delete`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      imageId
    })
  })
  .then((response) => response.json());
}

// Make a POST request to the /api/v1/archiveCreators API
function createArchive(images, folderName) {
  return fetch(`/api/${_VERSION}/archiveCreators`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      input: {
        archives: [{
          name: folderName,
          images: images.map((image) => ({
            imageId: image.imageId,
            filename: removeExtension(simplifyUrl(image.originalImage.name))
          }))
        }]
      }
    })
  })
    .then(checkStatus)
    .then((response) => response.json());
}

// Get the URL to download the archive
function getArchiveUrl(archiveId, filename) {
  let url = `/api/${_VERSION}/archives/${archiveId}`;

  if (filename) {
    url += `?contentDispositionFilename=${removeExtension(filename)}`;
  }

  return url;
}

export default {
  BASE_URL,
  postImages,
  getImageDirectUrl,
  getImageUrl,
  requestImageMetadata,
  updateImageMetadata,
  reportImage,
  editImages,
  deleteImage,
  createArchive,
  getArchiveUrl
};



// WEBPACK FOOTER //
// ./src/modules/ImageresizeApi/ImageresizeApi.js